<template>
  <div :class="{ lock: data.lock }">
    <div class="relative rounded-lg">
      <div class="square relative">
        <img
          :src="data.image_logo"
          alt=""
          class="advertisements__item__media"
        />
      </div>
    </div>
    <div
      class="flex flex-col items-center justify-items-center justify-center p-3 mb-3"
    >
      <div class="w-56 text-sm text-center">
        <p class="leading-5">{{ data.title }}</p>
      </div>
      <p class="text-sm font-semibold my-2">by {{ data.author }}</p>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import { useStore } from "vuex";
export default {
  props: {
    data: Object,
    lock: Boolean,
  },
  setup() {
    const store = useStore();
    const primaryTextClamp = ref(true);
    const copied = ref(false);
    const user = computed(() => store.state.user);
    const role = computed(() => store.state.role);
    const togglePrimaryTextClamp = () => {
      primaryTextClamp.value = !primaryTextClamp.value;
    };
    const copyToClipboard = (value) => {
      navigator.clipboard.writeText(value);
      copied.value = true;
      setTimeout(() => {
        copied.value = false;
      }, 3000);
    };
    const openOurPlansModal = () => {
      store.commit("SET_OURPLANS_ACTIVE", true);
    };
    const toggleFavoriteState = async (ad) => {
      if (["free"].includes(role.value)) {
        openOurPlansModal();
        return true;
      }

      if (ad.isFavorite) {
        await store.dispatch("REMOVE_FAVORITE_ADD", {
          user_id: user.value.id,
          advertisement_id: ad.id,
        });
      } else {
        await store.dispatch("ADD_FAVORITE_AD", {
          user_id: user.value.id,
          advertisement: ad,
        });
      }
    };

    return {
      primaryTextClamp,
      togglePrimaryTextClamp,
      toggleFavoriteState,
      copyToClipboard,
      copied,
    };
  },
};
</script>

<style scoped>
/* .post {
  filter: blur(8px);
} */
.lock {
  filter: blur(12px);
  pointer-events: none;
}
.text-606770 {
  color: #606770;
}
.square {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 5px;
  background-color: #fff;
}
.square img {
  border-radius: 10px;
}
.clamp {
  max-height: calc(1rem * 7);
  display: -webkit-box;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.discount {
  max-width: 10rem;
}
.action {
  max-width: 100px;
  letter-spacing: normal;
  color: rgb(68, 73, 80);
  font-size: 12px;
  font-weight: bold;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, Arial, sans-serif;
  line-height: 26px;
  text-align: center;
  height: 30px;
  background-position: 0 0;
  border: 1px solid #667eea;
  border-radius: 10px;
  box-shadow: none;
  box-sizing: border-box;
  cursor: pointer;
  -webkit-font-smoothing: antialiased;
  font-weight: bold;
  padding: 0 11px;
  position: relative;
  text-shadow: none;
  transition: all 300ms cubic-bezier(0.1, 0.7, 0.1, 1), border-width 1ms;
  transition-property: background, border-color, border-width, color;
  vertical-align: middle;
}
</style>
